import React from 'react';
import glamorous from 'glamorous';
import { connect } from 'react-redux';
import { NavLink } from 'redux-first-router-link';

import { getLocationQuery } from '../reducers/location';

import * as routeTypes from '../routes/types';

import { media, palette } from '../styles';

const navLinks = [
  {
    title: 'Home',
    route: {
      type: routeTypes.ROUTE_HOME,
    },
  },
  {
    title: 'Events',
    route: {
      type: routeTypes.ROUTE_EVENTS,
    },
  },
];

const styleNavLink = {
  display: 'inline-block',
  color: palette.white.darkest,
  textDecoration: 'none',
  textTransform: 'uppercase',
  lineHeight: '56px',
};

const styleNavLinkActive = {
  color: palette.white.base,
};

const NavLinksContainer = glamorous.div(({ theme, ...props }) => ({
  userSelect: 'none',

  '& > .NavLink': {
    marginRight: 8,
    marginLeft: 8,
  },

  [media('sm', { isMax: true })]: !props.isHome && {
    zIndex: 100,
    position: 'absolute',
    top: '100%',
    left: 0,
    right: 0,

    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    backgroundColor: theme.primary[600],

    boxShadow: props.isViewingMobileMenu ? '0px 6px 6px 0px rgba(0,0,0,0.54)' : undefined,

    transform:
      props.isViewingMobileMenu ? 'translateY(0)' : 'translateY(calc(-100% - 56px))',

    '& > .NavLink': {
      paddingLeft: 16,
      paddingRight: 16,
      borderTop: `1px solid ${theme.primary.darker}`,
      marginRight: 0,
      marginLeft: 0,
    },
  },
}));

class NavContainer extends React.PureComponent {
  renderNavLink = (link) => {
    const to = {
      ...link.route,
      query: this.props.locationQuery,
    };

    return (
      <NavLink
        className="NavLink"
        key={link.route.type}
        to={to}
        activeStyle={styleNavLinkActive}
        style={styleNavLink}
        exact={link.route.type === routeTypes.ROUTE_HOME}
        isActive={(match, location) => location.type.indexOf(link.route.type) === 0}
      >
        {link.title}
      </NavLink>
    );
  };

  render() {
    return (
      <NavLinksContainer
        isHome={this.props.isHome}
        isViewingMobileMenu={this.props.isViewingMobileMenu}
      >
        {navLinks.map(this.renderNavLink)}
      </NavLinksContainer>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  locationQuery: getLocationQuery(state),
  ...ownProps,
});

export default connect(mapStateToProps)(NavContainer);



// WEBPACK FOOTER //
// ./src/containers/NavContainer.js